export default __webpack_public_path__ + "static/media/img1.22da9ce5.png";